import React from "react";
import Navbar from "../components/Navbar";
import Profile from "../components/Profile";

function Profilepage() {
  return (
    <>
      <Navbar />
      <Profile />
    </>
  );
}

export default Profilepage;
